import { FeedbackSentiment } from "@/api/types";
import { HStack } from "@chakra-ui/react";
import React from "react";
import { FeedbackIcon } from "./FeedbackIcon";

interface Props {
  value?: FeedbackSentiment;
  onSelect: (type: FeedbackSentiment) => void;
  isDisabled?: boolean;
}

const types = [FeedbackSentiment.ThumbsUp, FeedbackSentiment.ThumbsDown];

export const FeedbackSentimentSelect = ({
  value,
  onSelect,
  isDisabled,
}: Props) => {
  return (
    <HStack
      spacing="14"
      pointerEvents={isDisabled ? "none" : "auto"}
    >
      {types.map((type) => (
        <FeedbackIcon
          key={type}
          isActive={value === type}
          type={type}
          onClick={() => onSelect(type)}
        />
      ))}
    </HStack>
  );
};
